import styled from "styled-components";

const StyledEntry = styled.div`
	.sb-blog {
		background-color: #000000;

		* {
			font-family: "Inter", sans-serif;
		}

		.sb-button__inner {
			font-weight: 400;
		}

		span.highlight {
			color: #f95c25;
		}

		.clash-display {
			font-family: "Clash Display", sans;
			font-weight: 500;
		}

		.orange-btn {
			background-color: #f95c25;
			color: #ffffff;
			font-size: 16px;
		}
		.transparent-btn {
			background-color: transparent;
			border: 1px solid;
			color: #f95c25;
			font-size: 16px;
		}

		&__main-section {
			height: 100vh;
			background-size: cover;
			background-position: center;
			display: flex;
			flex-direction: column;

			.header {
				display: flex;
				justify-content: space-between;
				align-items: center;
				padding: 20px 80px 0 80px;
				@media (max-width: ${({ theme }) => theme.responsive.mobile}) {
					padding: 20px;
				}
				z-index: 3;
				flex-wrap: wrap;

				@media (max-width: ${({ theme }) => theme.responsive.mobile}) {
					justify-content: center;
				}

				.actions {
					display: flex;
					gap: 12px;
					@media (max-width: ${({ theme }) => theme.responsive.mobile}) {
						display: none;
					}
					button {
						width: max-content;
						min-width: auto;
					}
				}
			}

			&::before {
				content: "";
				position: absolute;
				top: 0;
				left: 0;
				right: 0;
				bottom: -32px;
				background: linear-gradient(to bottom, rgba(0, 0, 0, 0.85), rgba(0, 0, 0, 1));
				@media (max-height: 575px) {
					bottom: -400px;
				}
			}
			.body {
				display: flex;
				flex-direction: column;
				gap: 16px;
				text-align: left;
				width: 100%;
				padding: 40px 80px;
				z-index: 999;
				@media (max-width: ${({ theme }) => theme.responsive.mobile}) {
					padding: 20px;
				}

				.title {
					@media (max-width: ${({ theme }) => theme.responsive.mobile}) {
						font-size: 22px;
					}
					font-size: 36px;
					color: white;
				}

				.created-at {
					font-size: 14px;
					font-weight: 400;
					color: #8c8c8c;
				}

				.category {
					text-transform: uppercase;
					font-size: 18px;
					font-weight: 700;
					color: #f95c25;
					@media (max-width: ${({ theme }) => theme.responsive.mobile}) {
						font-size: 16px;
					}
				}
			}
		}
		&__entry-section {
			position: relative;
			p,
			h1 {
				padding: 0 80px;
				@media (max-width: ${({ theme }) => theme.responsive.mobile}) {
					padding: 0 20px;
				}
			}

			&__thumbnail {
				height: 520px;
				background-size: cover;
				background-position: center;
				margin: 0 80px 32px 80px;
				@media (max-width: ${({ theme }) => theme.responsive.mobile}) {
					height: 220px;
					margin-left: 20px;
					margin-right: 20px;
				}
			}

			&__content {
				margin: 40px 0 0 0;
				color: white;
				line-height: 1.5;
				background: #000;
				overflow: hidden;
				display: -webkit-box;
				-webkit-line-clamp: 4;
				-webkit-box-orient: vertical;
				transition: height 0.4s ease;
			}

			&__expanded-content {
				margin: 40px 0 0 0;
				color: white;
				line-height: 1.5;
				transition: height 0.4s ease;
				background: #000;
				padding: 0;
			}

			p {
				color: white;
				padding-bottom: 12px;
			}
			.more-section {
				background-color: #000;
				padding: 32px 0;
			}
			.read-more-btn {
				width: max-content;
				max-width: max-content;
				display: flex;
				justify-content: center;
				border-color: transparent;
				font-size: 14px;
			}
		}
		&__items-section {
			padding: 80px;
			background-color: #000;
			@media (max-width: ${({ theme }) => theme.responsive.mobile}) {
				padding: 20px;
			}

			.title {
				color: #ffffff;
				font-size: 40px;
			}
		}
		&__footer {
			@media (max-width: ${({ theme }) => theme.responsive.mobile}) {
				padding: 16px 32px;
			}
			z-index: 3;
			background: #000;
			padding: 40px 80px;
			display: flex;
			flex-direction: column;
			align-items: center;
			gap: 24px;

			.divider {
				border-color: #1f1f1f;
			}

			.copyright {
				color: #d9d9d9;
				font-size: 14px;
			}
		}
	}
`;

export default StyledEntry;

